import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wheel-banner" }
const _hoisted_2 = { class: "wheel-banner__content" }
const _hoisted_3 = ["innerHTML"]

import WebpImage from "@sazka/design-system/src/image/webp-image.vue";
import DsButton from "@sazka/design-system/src/button/ds-button.vue";
import { computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'wheel-banner',
  props: {
    isCoin: { type: Boolean },
    text: {},
    link: {}
  },
  emits: ["clickButton"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const imageSrc = computed(() =>
    props.isCoin
        ? "/frontend/kasa-loyalty/img/widgets/wheel-campaign/Coin-with-shadow.png"
        : "/frontend/kasa-loyalty/img/homepage/obtainable-bonus.png"
);

const imageAlt = computed(() => (props.isCoin ? "zlatá mince" : "získejte bonus"));

const imageClass = computed(() => (props.isCoin ? "wheel-banner__coin" : "wheel-banner__bonus"));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(WebpImage, {
      class: _normalizeClass(imageClass.value),
      src: imageSrc.value,
      alt: imageAlt.value,
      get2x: !props.isCoin
    }, null, 8, ["class", "src", "alt", "get2x"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "wheel-banner__text",
        innerHTML: _ctx.text
      }, null, 8, _hoisted_3),
      _createVNode(DsButton, {
        class: "wheel-banner__button",
        href: _ctx.link,
        type: "text",
        "icon-right": "arrow-right",
        size: "sm",
        "event-name": _ctx.isCoin ? 'openLinkBrowser' : undefined,
        "event-argument": _ctx.isCoin ? _ctx.link : undefined,
        "open-in-new-tab": _ctx.isCoin ? true : undefined,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('clickButton')))
      }, {
        default: _withCtx(() => _cache[1] || (_cache[1] = [
          _createTextVNode("Více informací")
        ])),
        _: 1
      }, 8, ["href", "event-name", "event-argument", "open-in-new-tab"])
    ])
  ]))
}
}

})